import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Searchbox } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './AddServices.module.scss';
import { AddServicesTestIds } from './AddServicesTestIds';
export const AddServicesSearchbox = (param)=>{
    let { searchTerm, onSearchChange, onSearchClear } = param;
    const { t: includedServicesTexts } = useLocaleKeys('components.includedServices');
    return /*#__PURE__*/ _jsx(Searchbox, {
        bi: {
            name: 'included_services_search'
        },
        className: styles.searchbox,
        testId: AddServicesTestIds.SearchInput(),
        placeholder: includedServicesTexts.searchPlaceholder(),
        value: searchTerm,
        onChange: (e)=>onSearchChange(e.target.value),
        onClear: onSearchClear
    });
};
